export default __webpack_public_path__ + "static/media/net-dropdown.6a3c5e77.webp";